import supabase from "./supabase";

// Function to get all tasks from the taskManager table
export async function getTasks() {
  const { data, error } = await supabase
    .from("taskManager")
    .select("*")
    .order("id", { ascending: true }); // Order by the 'id' column in ascending order

  if (error) {
    console.error("Error loading tasks:", error);
    throw new Error("Could not load tasks");
  }

  return data;
}

// Function to delete a task by ID
export async function deleteTask(id) {
  const { error } = await supabase.from("taskManager").delete().eq("id", id); // Delete row where column "id" equals the given ID

  if (error) {
    console.error("Error deleting task:", error);
    throw new Error("Could not delete task");
  }

  return { success: true };
}

// Function to create or edit a task
export async function createEditTask(newTask) {
  const { id, ...taskData } = newTask; // Destructure to separate id from the rest of the task data
  let data, error;

  if (id) {
    // Edit an existing task
    ({ data, error } = await supabase
      .from("taskManager")
      .update(taskData)
      .eq("id", id)
      .select()
      .single());
  } else {
    // Create a new task
    ({ data, error } = await supabase
      .from("taskManager")
      .insert([taskData])
      .select()
      .single());
  }

  if (error) {
    console.error("Error creating or editing task:", error);
    throw new Error("Could not create or edit task");
  }

  return data;
}

// Function to swap rows up by exchanging their IDs in the taskManager table
export async function swapRowUp(currentRow, aboveRow) {
  try {
    const tempId = -1 * Math.max(currentRow.id, aboveRow.id) - 1; // Generate a temporary ID to avoid conflict

    // Temporarily set the ID of the current row to avoid conflict
    await supabase
      .from("taskManager")
      .update({ id: tempId })
      .eq("id", currentRow.id);

    // Swap IDs between the current row and the above row
    await supabase
      .from("taskManager")
      .update({ id: currentRow.id })
      .eq("id", aboveRow.id);
    await supabase
      .from("taskManager")
      .update({ id: aboveRow.id })
      .eq("id", tempId);
  } catch (error) {
    console.error("Error swapping rows up:", error);
    throw new Error("Could not swap rows up");
  }
}

// Function to swap rows down by exchanging their IDs in the taskManager table
export async function swapRowDown(currentRow, belowRow) {
  try {
    const tempId = -1 * Math.max(currentRow.id, belowRow.id) - 1; // Generate a temporary ID to avoid conflict

    // Temporarily set the ID of the current row to avoid conflict
    await supabase
      .from("taskManager")
      .update({ id: tempId })
      .eq("id", currentRow.id);

    // Swap IDs between the current row and the below row
    await supabase
      .from("taskManager")
      .update({ id: currentRow.id })
      .eq("id", belowRow.id);
    await supabase
      .from("taskManager")
      .update({ id: belowRow.id })
      .eq("id", tempId);
  } catch (error) {
    console.error("Error swapping rows down:", error);
    throw new Error("Could not swap rows down");
  }
}
